import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import AudioVideo from "../images/AUDIO VIDEO.jpg";
import audiovideoimg from "../images/Audio Video.jpeg";
import audiovideo from "../images/Audio video img.jpg";
import audiovideophoto from "../images/Audio video photo.jpg"

function Audio() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Audio Video</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    
          <div className="album py-2">

        <div className="container ">
          <div className='radiusimg'>
            <img src={audiovideoimg} className="d-block w-100" alt="audiovideo"/>
            </div>
</div>
</div>
<br/>
      
      <div className="album py-0">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{color:"#030D54"}}> <b>Audio Video</b></h1>
               <div className="col-md-4">
 <hr />
               </div>
              
              <p className='justify'>Our Audio Video solutions deliver crystal-clear sound and high-quality visuals for homes, offices, shops, and commercial spaces. From home theatre setup and smart TV installation to conference room audio systems, projectors, and professional display setups, we ensure smooth performance with expert installation and reliable support.</p>
              <br />
              
               <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
               <br/>
               <br/>
            </div>
            <div className="col-md-4">
                    <img src={AudioVideo} className="d-block w-100" alt="AudioVideo"/>

            </div>
          </div>

        </div>
      </div>
   <div className='computershopberhampore'>
           <br />
      <div className="album py-1">

        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={audiovideo} className="card-img-top" alt="audiovideo" />
                <div className='card-body'>
                  <h5 style={{color:"darkblue"}} className='mb-1'><b>Audio Video</b></h5>
                  <p className='mb-0'>Best Brand Audio Video Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={audiovideophoto} className="card-img-top" alt="audiovideophoto"/>
                <div className='card-body'>
               <h5 style={{color:"darkblue"}} className='mb-1'><b>Audio Video</b></h5>
                  <p className='mb-0'>Best Brand Audio Video Available</p>
                </div>
              </div>
            </div>
      



         


          </div>
        </div>
      </div>
         <br />
         <br/>
      </div>
  <br/>
    </div>
  )
}

export default Audio